import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import Icon from 'components/Icon';
import { helperGetFindUrl, helperGoToRelativeUrl } from 'helpers/RouteHelper';
import { setSearchValueCookie } from 'helpers/ContentHelper';
import { TABLET_LANDSCAPE_BREAKPOINT } from 'helpers/BreakpointHelper';
import Style from './SearchBox.module.scss';

const SearchBox = () => {
  const [focusSearch, setFocusSearch] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const { searchbox_inputPlaceholder: placeholderText } = window.Language;
  const focusClass = focusSearch ? Style.focusSearch : null;
  const inputClass = searchInput?.length > 0 ? Style.inputTyped : null;
  const currentBreakpoint = _.get(window, 'innerWidth');

  const setFocus = (val, clear) => {
    setFocusSearch(val);
    if (clear) {
      onClearSearch();
    }
  };

  const onSearchChange = _.debounce(text => {
    setSearchInput(text);
    const path = { path: '/' };
    if (text.length >= 2) {
      setSearchValueCookie({ value: text, options: path });
      helperGoToRelativeUrl(helperGetFindUrl());
      onClearSearch();
    }
  }, 800);

  const onClearSearch = useCallback(() => {
    setSearchInput('');
    document.getElementById('searchGlobal').value = '';
  }, []);

  return (
    <div className={classNames(Style.searchInputBox, focusClass)}>
      <button className={Style.searchIconButton} onClick={() => setFocus(true)}>
        <Icon className={Style.searchIcon} icon="search-icon" />
      </button>
      <>
        <input
          type="text"
          id="searchGlobal"
          name="searchGlobal"
          autoComplete="off"
          placeholder={placeholderText}
          onChange={e => onSearchChange(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => (currentBreakpoint >= TABLET_LANDSCAPE_BREAKPOINT ? setFocus(false) : null)}
        />
        <button
          className={classNames(Style.closeIconButton, inputClass)}
          onMouseDown={() => onClearSearch()}
        >
          <Icon icon="close" />
        </button>
      </>
    </div>
  );
};

export default SearchBox;
